import styled from 'styled-components';

import {colors} from '@app/styles/theme';

import {Icon} from '@shared/ui/Icon';

export const Root = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;

export const CancelIcon = styled(Icon)`
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(-100%, -50%);

    svg {
        stroke: ${colors.textSecondary};
    }

    :hover {
        svg {
            stroke: ${colors.textPrimary};
        }
    }
`;
